import React from "react";
import ashleyGift from "../Images/ashley-gift.png";
function GiftBox() {
  return (
    <div className="row">
    <div className="col-md-1">
      <img
        src={ashleyGift}
        alt="ashley-gift.png"
      />
    </div>

    <div className="col-md-11" style={{ fontFamily: "Arial" }}>
      {/* Once you receive your email from{" "} */}
      Once you receive and action your email from{" "}
      <a href="mailto:notification@prepaiddigitalsolutions.com">
          {process.env.REACT_APP_PREP}
      </a>{" "}
      or{" "}<br/>
      <a href="mailto:no-reply@hawkmarketplace.com">
          {process.env.REACT_APP_MARKET_PLACE}
      </a>
      , you can use the reward card virtually or request a card to be mailed to you.
      {/* , you can use the card virtually! */}
    </div>
  </div>
  );
}
export default GiftBox;
